/**
 * poll until condition is true.
 *
 * @param {*} action the action to perform periodically
 * @param {Function} isSuccessful a callback to check whether the result is successful
 * @param {Function} isFailed a callback to check whether the result is failed
 * @param {Number} interval poll interval in ms
 * @returns {Promise<void>} void
 */
export async function poll(action, isSuccessful, isFailed, interval = 6000) {
  return new Promise(((resolve, reject) => {
    const timerId = setInterval(async () => {
      const result = await action();

      if (isSuccessful(result)) {
        clearInterval(timerId);
        resolve(result);
      }

      if (isFailed && isFailed(result)) {
        clearInterval(timerId);
        reject(result);
      }
    }, interval);
  }));
}
